import { Paragraph, XStack, YStack } from 'tamagui';
import { citationChips } from '../../lib/chat-view';
import type { ThreadMessage } from '../../lib/chat-hooks';

/** One chat bubble: user right-aligned, assistant left-aligned with citation chips. */
export function MessageBubble({ message }: { message: ThreadMessage }) {
  const isUser = message.role === 'user';
  const chips = isUser ? [] : citationChips(message);
  return (
    <YStack
      testID="chat-message"
      // Assistant bubbles are polite live regions so a new reply (and the
      // pending 'thinking…' state) is announced to assistive tech, reading the
      // same on-screen text — never the user's outgoing message.
      aria-live={isUser ? undefined : 'polite'}
      aria-atomic={isUser ? undefined : true}
      alignSelf={isUser ? 'flex-end' : 'flex-start'}
      maxWidth="90%"
      gap="$2"
      padding="$3"
      borderRadius="$4"
      backgroundColor={isUser ? '$blue4' : '$color3'}
    >
      <Paragraph color={message.pending ? '$color10' : '$color12'}>{message.content}</Paragraph>
      {chips.length > 0 ? <CitationChips chips={chips} /> : null}
    </YStack>
  );
}

function CitationChips({ chips }: { chips: string[] }) {
  return (
    <XStack gap="$2" flexWrap="wrap">
      {chips.map((chip) => (
        <Paragraph
          key={chip}
          size="$1"
          paddingHorizontal="$2"
          paddingVertical={2}
          borderRadius="$2"
          backgroundColor="$color5"
          color="$color11"
          fontWeight="600"
        >
          {chip}
        </Paragraph>
      ))}
    </XStack>
  );
}
